import {RootState} from "../../store";
import {VideoPage} from "../../../types/video";

export const selectVideoPage = (state: RootState): VideoPage => state.video.page;
export const selectActiveRoomId = (state: RootState): VideoPage => state.video.activeRoomId;